import React from 'react'
import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from '@progress/kendo-react-grid'

interface ColumnCheckboxFilterProps extends GridColumnMenuProps {
  data: string[] | object[]
}

export const ColumnCheckboxFilter: React.FC<ColumnCheckboxFilterProps> = (
  props: ColumnCheckboxFilterProps
) => (
  <div>
    <GridColumnMenuCheckboxFilter {...props} data={props.data} expanded />
  </div>
)
